export default __webpack_public_path__ + "static/flirting-3a06e6355065fd88f8b2b8aca0e03a5e.svg";